import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Der Hinweis, dass eine Live-Ansicht ihre Verbindung verloren hat und sich neu
 * verbindet (NEX-1307). Den Text bringt der Aufrufer als Schluessel mit: der
 * Runner und das Dashboard sagen dem Nutzer Verschiedenes darueber, was er noch
 * sieht.
 *
 * <p>Den Abstand nach aussen setzt die aufrufende Seite am Wirt — der Hinweis
 * sitzt im Runner ueber dem Inhalt, im Dashboard ueber der Karte seiner Sektion.
 */
@Component({
  selector: 'app-live-reconnect-hint',
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './live-reconnect-hint.component.html',
  styleUrl: './live-reconnect-hint.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveReconnectHintComponent {
  readonly messageKey = input.required<string>();
  /** Werte für Platzhalter im Text, etwa `{{time}}` im Stand-Hinweis der Rechner-Übersicht. */
  readonly messageParams = input<Record<string, unknown> | undefined>(undefined);
}
